var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3335 0.333252H17.6668C24.2943 0.333252 29.6668 5.70584 29.6668 12.3333V17.6666C29.6668 24.294 24.2943 29.6666 17.6668 29.6666H12.3335C5.70608 29.6666 0.333496 24.294 0.333496 17.6666V12.3333C0.333496 5.70584 5.70608 0.333252 12.3335 0.333252ZM17.6668 2.99992H12.3335C7.17884 2.99992 3.00016 7.1786 3.00016 12.3333V17.6666C3.00016 22.8212 7.17884 26.9999 12.3335 26.9999H17.6668C22.8215 26.9999 27.0002 22.8212 27.0002 17.6666V12.3333C27.0002 7.1786 22.8215 2.99992 17.6668 2.99992Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.5319 8.08008C14.8971 8.25883 14.4408 8.53307 13.9174 9.06993C13.1825 9.83327 12.9931 10.5253 12.9154 12.6963L12.8597 14.5211H11.9354H11V16.0717V17.6222H11.9466H12.8931L12.9154 22.7753L12.9488 27.9403L14.7637 27.9761L16.5676 28V22.8111V17.6222H18.0039H19.4402L19.507 17.2883C19.5404 17.1093 19.5962 16.4175 19.6407 15.7378L19.7076 14.5211H18.1376H16.5676V13.4C16.5676 12.0998 16.6902 11.6345 17.091 11.408C17.3805 11.2409 18.2156 11.1935 19.1287 11.3006L19.6299 11.3603L19.8413 9.9049C19.9639 9.0938 20.0307 8.40207 19.9861 8.36626C19.7407 8.09202 16.2779 7.87716 15.5319 8.08008Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.04e9ddb4a0f4ffa96acb594804d882a3.svg";
export { ForwardRef as ReactComponent };